<template>
  <div id="stdb-search-problem">
    <div ref="searchModal" class="stdb-modal stdb-search">
      <div class="stdb-modal-dialog">
        <form
ref="searchProblemForm" method="post" target="search-problem"
          :action="originAllow + '/search_problem'">
          <input type="hidden" name="api_token" :value="apiToken" />
          <input type="hidden" name="print_id" :value="`${printId};${originAllow}/`" />
        </form>
        <iframe name="search-problem"></iframe>
      </div>
    </div>
    <div v-show="showLoading" class="stdb-modal">
      <div class="stdb-confirm-dialog stdb-loading">
        <div class="stdb-modal-body">
          <div>読み込み中です</div>
          <div class="stdb-loading-overlay">
            <div class="stdb-loading-spinner"></div>
          </div>
        </div>
        <div class="stdb-modal-footer">
          <button @click="cancel">キャンセル</button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import mixin from "@/mixins/mixin"
import stdbRepository from "@/repositories/stdb"

export default {
  name: "StdbSearchProblem",
  components: {},
  mixins: [mixin],
  props: {
    stdbToken: {
        type: String,
        required: true
    }
  },
  emits: [
    "close",
    "error",
    "complete",
  ],
  data: function () {
    return {
        printId: 'sviewer',
        apiToken: '',
        showLoading: false,
        originAllow: import.meta.env.VUE_APP_STDB_SEARCH_BASE_URL,
    }
  },
  computed: {},
  async mounted() {

  },
  methods: {
    showStdbSearchProblem() {
        this.apiToken = this.loginUserInfo.stdbToken
        // 問題検索iframeから送信されるメッセージを監視
        window.removeEventListener('message', this.listener)
        window.addEventListener('message', this.listener)
        this.$nextTick(() => {
          this.$refs.searchModal.style.display = 'block'
          this.$refs.searchProblemForm.submit()
        })
        this.showLoading = true
    },
    listener: function (response) {
        if (!response || response.origin !== this.originAllow) {
            return
        }

        if (response.data.type === 'LoadComplete') {
            if (this.showLoading === true) {
              // 問題検索ダイアログ表示
              this.showLoading = false
              this.$refs.searchModal.style.visibility = 'visible'
            }
        } else if (response.data.type === 'LayoutProblem') {
            // レイアウト実行
            this.downloadProblem(response.data.data)
        } else if (response.data.type === 'CancelSearch') {
            // 問題検索ダイアログ非表示
            this.close()
            this.$emit('close')
        }
    },
    downloadProblem: async function (problemList) {
        const stdbToken = this.stdbToken

        try {
            if (!stdbToken) {
                this.$emit('close')
                return
            }
            if (!problemList) {
                // TODO: 問題未選択
                this.$emit('close')
                return
            }

            // パラメータ組み立て
            const params = new FormData()
            params.append('api_token', encodeURIComponent(stdbToken))
            params.append('print_id', `${this.printId};${this.originAllow}`)
            for (let i = 0; i < problemList.length; i++) {
            const problem = problemList[i]
            // 問題IDが無い問題は処理しない
            if (!problem || !problem.editor_problem_id) continue
            // 問題IDをパラメータに追加
            params.append(`problem[${i}]`, problem.editor_problem_id)
            }

            // 問題ダウンロード
            const response = await stdbRepository.downloadProblem(params)
            if (!response || response.result_code !== '00000' || !response.download_zip) {
              console.error(response)
              this.$emit('error')
              return
            }

            // 問題ZIPダウンロード
            const zipData = await stdbRepository.downloadProblemZip(response.download_zip)
            if (!zipData) {
              console.error(`ZIPファイルの取得に失敗しました。${response}`)
              this.$emit('error')
              return
            }
            this.$emit('complete', zipData)
        } catch (error) {
            console.error(error)
            this.$emit('error')
        } finally {
            this.close()
        }
    },
    cancel: function () {
        this.close()
        this.$emit('close')
    },
    close: function () {
        window.removeEventListener('message', this.listener)
        this.$refs.searchModal.style.display = 'none'
        this.$refs.searchModal.style.visibility = 'hidden'
        this.showLoading = false
    },
    show() {
        this.showStdbSearchProblem()
    }
  }
}
</script>

<style lang="scss" scoped>
.stdb-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.3);

  &.stdb-search {
    display: none;
    visibility: hidden;
  }

  .stdb-modal-dialog {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    height: 98%;
    width: 98%;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    border-radius: 6px;
    background-color: #fff;

    form {
      display: none;
    }

    iframe {
      height: 100%;
      width: 100%;
      border: none;
      border-radius: 6px;
    }
  }

  .stdb-confirm-dialog {
    position: absolute;
    width: 400px;
    height: 160px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    border-radius: 6px;
    background-color: #fff;
    text-align: center;

    &.stdb-loading {
      width: 250px;
    }

    .stdb-modal-body {
      padding: 15px 15px 10px 15px;
      font-size: 16px;

      .stdb-loading-overlay {
        margin-top: 5px;

        .stdb-loading-spinner {
          margin: auto;
          animation-duration: 0.75s;
          animation-iteration-count: infinite;
          animation-name: rotate-forever;
          animation-timing-function: linear;
          height: 30px;
          width: 30px;
          border: 8px solid rgba(0, 0, 0, 0.3);
          border-right-color: transparent;
          border-radius: 50%;
          display: inline-block;
        }

        @keyframes rotate-forever {
          0% {
            transform: rotate(0);
          }

          100% {
            transform: rotate(360deg);
          }
        }
      }
    }

    .stdb-modal-footer {
      padding: 15px;
      border-top: 1px solid #e5e5e5;

      button {
        cursor: pointer;
        height: 38px;
        width: 94px;
        color: rgb(51, 51, 51);
        border: 1px solid rgb(204, 204, 204);
        border-radius: 4px;
        background-image: linear-gradient(rgb(255, 255, 255) 0px,
            rgb(224, 224, 224) 100%);
      }

      :hover {
        background-image: linear-gradient(rgb(245, 245, 245) 0px,
            rgb(214, 214, 214) 100%);
      }
    }
  }
}
</style>